import { render, staticRenderFns } from "./templateSettings.vue?vue&type=template&id=60ebe82b&"
import script from "./templateSettings.vue?vue&type=script&lang=ts&"
export * from "./templateSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports